/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */

export function bindRef(component: $TSFixMe, attribute: $TSFixMe) {
  return (child: $TSFixMe) => (component[attribute] = child);
}

export const writeLocalStorage = (storageKey: $TSFixMe, value: $TSFixMe) =>
  global.localStorage.setItem(storageKey, value);

export const readLocalStorage = (storageKey: $TSFixMe) =>
  global.localStorage.getItem(storageKey);
